// Libraries
import axios from 'axios';
const api = process.env.REACT_APP_SERVER_ENDPOINT;

export default {
	/**
	 * List of Current Challenges
	 * URL: /challenge/
	 * Method: GET
	 * URL Params:
	 * - Required: none
	 * - Optional: none
	 * @returns
	 */
	listOngoingChallenges() {
		return axios.get(`${api}/challenge/`, {
			withCredentials: true,
		});
	},

	/**
	 * List of Past Challenges
	 * URL: /challenge/previous
	 * Method: GET
	 * URL Params: Required: none Optional: none\
	 * Success Response: 200
	 * Error Response: none
	 *
	 * @returns
	 */
	listPastChallenges() {
		return axios.get(`${api}/challenge/previous`, {
			withCredentials: true,
		});
	},

	/**
	 * List of Upcoming Challenges
	 * URL: /challenge/upcoming
	 * Method: GET
	 * URL Params: Required: none
	 * Optional: none\
	 * Success Response: 200
	 * Error Response: none
	 *
	 * @returns
	 */
	listFutureChallenges() {
		return axios.get(`${api}/challenge/upcoming`, {
			withCredentials: true,
		});
	},

	/**
	 * Find challenge by Id
	 *
	 * URL: /challenge/{challenge_id}
	 * Method: GET
	 * URL Params: Required: challenge_id
	 * Optional: none
	 * Success Response: 200
	 * Error Response: 404 Not found
	 * @param {*} challenge_id
	 * @returns
	 */
	findChallengeById(challenge_id) {
		return axios.get(`${api}/challenge/${challenge_id}`, {
			withCredentials: true,
		});
	},

	/**
	 * Join a challenge by Id
	 *
	 * URL: /challenge/{challenge_id}
	 * Method: PUT
	 * URL Params: Required: challenge_id
	 * Optional: none
	 * Success Response: 200 list of subscribed challenges
	 * Error Response: 404 Not found
	 *
	 * @param {*} challenge_id
	 * @returns
	 */
	joinChallengeById(challenge_id) {
		return axios.put(`${api}/challenge/${challenge_id}`, null, {
			withCredentials: true,
		});
	},

	/**
	 * List my currently subscribed challenges
	 *
	 * URL: /challenge/my
	 * Method: GET
	 * URL Params: Required: challenge_id
	 * Optional: none
	 * Success Response: 200 list of subscribed challenges
	 * Error Response: 404 Not found
	 *
	 * @returns
	 */
	listMyChallenges(challenge_id) {
		return axios.put(`${api}/challenge/${challenge_id}`, null, {
			withCredentials: true,
		});
	},

	/**
	 * Retrieve Individual scoreboard for challenge
	 *
	 * URL: /score/{challenge_id}
	 * Method: GET
	 * URL Params: Required: challenge_id
	 * Optional: none
	 * Success Response: 200
	 * Error Response: 404 Not found
	 *
	 * @param {*} challenge_id
	 * @returns
	 */
	getIndividualScoreboardForChallenge(challenge_id) {
		return axios.get(`${api}/score/${challenge_id}`, {
			withCredentials: true,
		});
	},

	/**
	 * Retrieve Team scoreboard for challenge
	 *
	 * URL: /score/team/{challenge_id}
	 * Method: GET
	 * URL Params: Required: challenge_id
	 * Optional: none
	 * Success Response: 200
	 * Error Response: 404 Not found
	 *
	 * @param {*} challenge_id
	 * @returns
	 */
	getTeamScoreboardForChallenge(challenge_id) {
		return axios.get(`${api}/score/team/${challenge_id}`, {
			withCredentials: true,
		});
	},

	/**
	 * Retrieves the score info for user on a specific challenge
	 *
	 * URL: /score/team/{challenge_id}/{user_id}
	 * Method: GET
	 * URL Params:
	 *  - Required:
	 *    - challenge_id
	 *    - user_id
	 * Optional: none
	 * Success Response: 200
	 * Error Response: 404 Not found
	 *
	 * @param {*} challenge_id
	 * @returns
	 */
	getUserScoreCardForChallenge(challenge_id, user_id) {
		return axios.get(`${api}/score/${challenge_id}/${user_id}`, {
			withCredentials: true,
		});
	},

	/**
	 * Return my ranking, totalGoal, percentage, ...
	 *
	 * URL: /score/{challenge_id}/my
	 * Method: GET
	 * URL Params: Required: challenge_id
	 * Optional: none
	 * Success Response: 200
	 * Error Response: 404 Not found
	 *
	 * @returns
	 */
	myStatusForChallenge(challenge_id) {
		return axios.get(`${api}/score/${challenge_id}/my`, {
			withCredentials: true,
		});
	},

	/**
	 * Return an array of photos from a specific challenge
	 *
	 * URL: /photos/{challenge_id}
	 * Method: GET
	 * URL Params:
	 * - Required: challenge_id
	 * - Optional: none
	 * Success Response: 200
	 * Error Response: 404 Not found
	 *
	 * @returns
	 */
	findLargePhotosByChallengeId(challenge_id) {
		return axios.get(`${api}/photo/${challenge_id}/big`, {
			withCredentials: true,
		});
	},

	findSmallPhotosByChallengeId(challenge_id) {
		return axios.get(`${api}/photo/${challenge_id}/small`, {
			withCredentials: true,
		});
	},

	/**
	 * Return an array with the stats of the app
	 *
	 * URL: /challengestats
	 * Method: GET
	 * URL Params:
	 * - Required: none
	 * - Optional: none
	 * Success Response: 200
	 * Error Response: 404 Not found
	 *
	 * @returns
	 */
	findGlobalStats() {
		return axios.get(`${api}/challengestats`, {
			withCredentials: true,
		});
	},

	/**
	 * Return an array with the stats of the challenge
	 *
	 * URL: /challengestats/{challenge_id}
	 * Method: GET
	 * URL Params:
	 * - Required: challenge_id
	 * - Optional: none
	 * Success Response: 200
	 * Error Response: 404 Not found
	 *
	 * @returns
	 */
	findStatsbyChallengeId(challenge_id) {
		return axios.get(`${api}/challengestats/${challenge_id}`, {
			withCredentials: true,
		});
	},

	deletePhotoByUserIdAndTimestamp(challenge_id, user_id, timestamp) {
		return axios.delete(`${api}/photo/${challenge_id}/${user_id}/${timestamp}`, {
			withCredentials: true,
		});
	},
};



// WEBPACK FOOTER //
// ./src/data/services/challenges-services.js